
<div *ngIf="input">
  <app-share-revocation [entityId]="input.entityId" [isStudy]="input.isStudy"></app-share-revocation>
  <mat-radio-group [formControl]="shareTypeFormControl" *ngIf="input.isStudy">
    <mat-radio-button color="primary" [value]="ShareModeEnum.ByReferingVet">{{'popup.share_study.by_refering_vet' | translate }}</mat-radio-button>
    <mat-radio-button color="primary" [value]="ShareModeEnum.ByEmail">{{'popup.share_study.by_email' | translate }}</mat-radio-button>
    <mat-radio-button color="primary" [value]="ShareModeEnum.ByApp">{{'popup.share_study.by_app' | translate }}</mat-radio-button>
  </mat-radio-group>
</div>

<app-share-by-refering-vet *ngIf="shareTypeFormControl.value == ShareModeEnum.ByReferingVet"></app-share-by-refering-vet>
<app-share-by-email *ngIf="shareTypeFormControl.value == ShareModeEnum.ByEmail"></app-share-by-email>
<app-share-by-app *ngIf="shareTypeFormControl.value == ShareModeEnum.ByApp"></app-share-by-app>